// eslint-disable-next-line no-restricted-imports
import { Dialog, createComponent } from '@workday/canvas-kit-react';
import { WcpCard } from '@workday/wcp-cargo-react';
import { ThemedSecondaryButton } from './ThemedSecondaryButton';

export const ThemedDialog = (props: React.ComponentProps<typeof Dialog>) => <Dialog {...props} />;

const ThemedDialogCloseButton = createComponent(ThemedSecondaryButton)({
  displayName: 'ThemedDialogButton',
  Component: (props: React.ComponentProps<typeof Dialog.CloseButton>, ref, Element) => (
    <Dialog.CloseButton as={Element} ref={ref} {...props} />
  ),
});

ThemedDialog.Body = Dialog.Body;
ThemedDialog.CloseButton = ThemedDialogCloseButton;
ThemedDialog.CloseIcon = Dialog.CloseIcon;
ThemedDialog.Card = WcpCard;
ThemedDialog.Heading = Dialog.Heading;
ThemedDialog.Target = Dialog.Target;
ThemedDialog.Popper = Dialog.Popper;
